module.exports = __webpack_public_path__ + "static/media/hacker.00de9045.webp";